import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NodeAPI from "../api";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { DataGrid } from "@mui/x-data-grid";


import { Button, Typography, Box, TextField, Select, MenuItem,Card,CardContent,CardActionArea,IconButton,Menu} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";


const TopicsList = () => {
    const { categoryId } = useParams();
    const [topics, setTopics] = useState([]);
    const [filteredTopics, setFilteredTopics] = useState([]);
    const [search, setSearch] = useState("");
    const { user } = useAuth();
    const navigate = useNavigate();

const exitTopics = () => {
        // ðŸ”’ Remove JWT token from localStorage or sessionStorage
        localStorage.removeItem("token"); // or sessionStorage.removeItem("token");
    
        // ðŸ§¹ Clear any user context if used
       // setUser(null); // If using AuthContext
   
    
        // ðŸšª Navigate to home or login page
        //navigate("/");
window.location.href = "/";
    };
    useEffect(() => {
        if (!user) return;
        NodeAPI.get(`/quiz/topics/${categoryId}?userId=${user.id}`)
            .then(({ data }) => {
                setTopics(data);
                setFilteredTopics(data.map((topic, index) => ({ ...topic, sequence: index + 1, playMode: "Basic" })));
            })
            .catch((err) => console.error("Error fetching topics:", err));
    }, [categoryId, user]);

    // Handle search filtering
    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearch(query);
        setFilteredTopics(
            topics
                .map((topic, index) => ({ ...topic, sequence: index + 1 }))
                .filter((topic) => topic.name.toLowerCase().includes(query))
        );
    };

    // Handle play mode change
    const handleModeChange = (id, mode) => {
        setFilteredTopics((prevTopics) =>
            prevTopics.map((topic) =>
                topic.id === id ? { ...topic, playMode: mode } : topic
            )
        );
    };

    // Handle navigation based on selected mode
    const handlePlay = (topic) => {
        const { id, playMode } = topic;
        let route = `/quiz/${id}`;

        if (playMode === "Gamified") {
            route = `/quiz/gamified/${id}`;
        } else if (playMode === "Interactive") {
            route = `/quiz/interactive/${id}`;
        }

        navigate(route, { state: { topic } });
    };


 // Menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (path) => {
    setAnchorEl(null);
    if (path) {
      navigate(path);
    }
  };

 const handleLogout = () => {
    localStorage.removeItem("token");
    setAnchorEl(null);
    navigate("/");
  };

const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this topic?")) return;
    
    try {
        await NodeAPI.delete(`/quiz/topic/${id}`);
        const updatedTopics = topics.filter((topic) => topic.id !== id);
        setTopics(updatedTopics);
        setFilteredTopics(
            updatedTopics.map((topic, index) => ({
                ...topic,
                sequence: index + 1,
                playMode: topic.playMode || "Basic"
            }))
        );
    } catch (err) {
        console.error("Failed to delete topic:", err);
        alert("An error occurred while deleting the topic.");
    }
};


    // Define table columns
    const columns = [
        { field: "sequence", headerName: "#", width: 70 },
        { 
            field: "name", 
            headerName: "Topic Name", 
            flex: 1,
            renderCell: (params) => (
                <Link to={`/quiz/${params.row.id}`} style={{ textDecoration: "none", color: "#1976d2", fontWeight: "bold" }}>
                    {params.value}
                </Link>
            )
        },
        {
            field: "playMode",
            headerName: "Play Mode",
            width: 150,
            renderCell: (params) => (
                <Select
                    value={params.row.playMode}
                    onChange={(e) => handleModeChange(params.row.id, e.target.value)}
                    size="small"
                >
                    <MenuItem value="Basic">Basic</MenuItem>
                   {/* <MenuItem value="Gamified">Gamified</MenuItem> */}
                    <MenuItem value="Interactive">Interactive</MenuItem>
                </Select>
            )
        },
        {
            /*field: "play",
            headerName: "Action",
            width: 120,
            renderCell: (params) => (
                <Button 
                    variant="contained" 
                    color="primary" 
                    size="small"
                    onClick={() => handlePlay(params.row)}
                >
                    Play
                </Button>
            )*/
            
              field: "play",
  headerName: "", // or "Action" if you want a label
  width: 60,
  sortable: false,
  align: "center",
  headerAlign: "center",
  renderCell: (params) => (
    <IconButton
      aria-label="play"
      color="primary"
      onClick={() => handlePlay(params.row)}
    >
      <PlayArrowIcon />
    </IconButton>
  ),
        },
        
    {
   field: "actions",
  headerName: "",
  width: 50, // or even 40 if you want it tighter
  sortable: false,
  align: "center",
  headerAlign: "center",
  renderCell: (params) => (
    <IconButton
      aria-label="delete"
      color="error"
      onClick={() => handleDelete(params.row.id)}
    >
      <DeleteIcon fontSize="small" />
    </IconButton>
  ),
}


    ];

  return (
    <>
      {/* Header with profile menu */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 4,
          mb: 2,
          px: 2,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          Quiz Topics
        </Typography>

        {/* Profile Icon with Menu */}
        <div>
          <IconButton
            color="primary"
            onClick={handleMenuClick}
            aria-controls="profile-menu"
            aria-haspopup="true"
            size="large"
          >
            <AccountCircleIcon />
          </IconButton>
          <Menu
            id="profile-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={() => handleMenuClose()}
          >
            <MenuItem onClick={() => handleMenuClose("/profile")}>Profile</MenuItem>
            <MenuItem onClick={() => handleMenuClose("/notifications")}>Quiz Notifications</MenuItem>
            <MenuItem onClick={() => handleMenuClose("/uploadquiz")}>Upload Quiz</MenuItem>
            <MenuItem onClick={() => handleMenuClose("/generate_quiz")}>Generate Quiz</MenuItem>
            <MenuItem onClick={() => handleMenuClose("/categories")}>Categories</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      </Box>

      {/* Search and DataGrid */}
      <Box sx={{ maxWidth: "800px", margin: "auto" }}>
        <TextField
          label="Search Topics"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          value={search}
          onChange={handleSearch}
        />
        <DataGrid
          rows={filteredTopics}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          disableSelectionOnClick
          getRowId={(row) => row.id}
          autoHeight
        />
      </Box>

      {/* Navigation Buttons */}
      <Box sx={{ mt: 4, display: "flex", justifyContent: "center", gap: 2 }}>
        <Button
          variant="outlined"
          color="info"
          onClick={() => navigate("/categories")}
          sx={{ fontWeight: "bold" }}
        >
          Back to Categories
        </Button>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/generate_quiz"
          sx={{ fontWeight: "bold" }}
        >
          Generate Quiz
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={exitTopics}
          sx={{ fontWeight: "bold" }}
        >
          Exit
        </Button>
      </Box>
    </>
  );
};

export default TopicsList;

